import * as React from "react";
const SvgGenerator = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 100, height: 100, viewBox: "0 0 100.0 100.0", ...props }, /* @__PURE__ */ React.createElement("ellipse", { cx: 50, cy: 50, rx: 50, ry: 50, fill: "none", stroke: "currentColor", strokeWidth: 1 }));
export default SvgGenerator;
